// extracted by mini-css-extract-plugin
module.exports = {"errorSubtitle":"styles-module-errorSubtitle--PNM4q"};